import {Injectable} from '@angular/core';
import {Actions, createEffect, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {
    PageState
} from './veranstaltungen.reducer';
import {
    getAktuelleRolle, getDokumentSelected, getSelectedFunktionsbereichId,
    getUiSelektiertFunktionsbereicheCheckliste,
    getVeranstaltungenDetail
} from './veranstaltungen.selectors';
import {NotificationService} from '@orga-app/providers/notification.service';
import {Observable} from 'rxjs';
import {WS_READ_MODEL_UPDATED, WsReadModelUpdatedAction} from '../../websocket.actions';
import {KommunikationEntityTypes, VeranstaltungenEntityTypes, VorlagenEntityTypes} from '../../../client-constants';
import VERANSTALTUNG_ENTITY = VeranstaltungenEntityTypes.VERANSTALTUNG_ENTITY;
import {filter, flatMap, map, mergeMap, withLatestFrom} from 'rxjs/operators';
import {
    GetChecklisteAufgabenAdminAction, GetMitteilungenGesendetGruppiertAction, GetMitteilungenGruppiertAction,
    GetRolleBenutzerAdminAction, GetVeranstaltungBenutzerZugriffAction, GetVeranstaltungBerechtigungAction,
    GetVeranstaltungDetailAdminAction, GetVeranstaltungDokumentBerechtigungAction, GetVeranstaltungDokumenteAdminAction,
    GetVeranstaltungenAngelegteAdminAction,
    GetVeranstaltungenBeendeteAdminAction,
    GetVeranstaltungenVeroeffentlichteAdminAction, GetVeranstaltungFunktionsbereicheAction,
    GetVeranstaltungFunktionsbereicheAdminAction,
    GetVeranstaltungFunktionsbereicheChecklistenAdminAction,
    GetVeranstaltungFunktionsbereicheRollenAdminAction, GetVeranstaltungFunktionsbereicheRollenAdminAlleAction
} from '../../../client-ngrx/veranstaltungen';
import {
    Aufgabe, Checkliste,
    ChecklisteStatus,
    Dokument,
    Funktionsbereich,
    Rolle,
    RolleBenutzer,
    VeranstaltungDetail
} from '../../../clients/veranstaltungen';
import {GetRolleBenutzerAction} from '../../../client-ngrx/benutzerverwaltung';
import ROLLE_ENTITY = VeranstaltungenEntityTypes.ROLLE_ENTITY;
import FUNKTIONSBEREICH_ENTITY = VeranstaltungenEntityTypes.FUNKTIONSBEREICH_ENTITY;
import * as actionsUi from './veranstaltungen.actions.ui';
import ROLLE_ENTITY_PART_BERECHTIGUNG = VeranstaltungenEntityTypes.ROLLE_ENTITY_PART_BERECHTIGUNG;
import DOKUMENT_ENTITY = VeranstaltungenEntityTypes.DOKUMENT_ENTITY;
import CHECKLISTE_ENTITY = VeranstaltungenEntityTypes.CHECKLISTE_ENTITY;
import CHECKLISTE_ENTITY_PART_STATUS = VeranstaltungenEntityTypes.CHECKLISTE_ENTITY_PART_STATUS;
import AUFGABE_ENTITY = VeranstaltungenEntityTypes.AUFGABE_ENTITY;
import {GetVeranstaltungPandemieInfoAction} from '../../../client-ngrx/pandemie';
import MITTEILUNG_ENTITY = KommunikationEntityTypes.MITTEILUNG_ENTITY;
import {FunktionsbereichSetzenAction} from './veranstaltungen.actions.ui';
import {getIstPandemieLizenzAktiv} from '@orga-app/mandant/reducer';
import DOKUMENT_ENTITY_PART_BERECHTIGUNG = VeranstaltungenEntityTypes.DOKUMENT_ENTITY_PART_BERECHTIGUNG;

@Injectable()
export class EffectsWs {

    @Effect()
    readModelUpdaterVeranstaltung$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === VERANSTALTUNG_ENTITY;
        })
        , flatMap(() => {
            const res = [];
            res.push(new GetVeranstaltungenAngelegteAdminAction());
            res.push(new GetVeranstaltungenVeroeffentlichteAdminAction());
            res.push(new GetVeranstaltungenBeendeteAdminAction());
            return res;
        })
    );


/*
    @Effect()
    readModelUpdaterAngelegteVeranstaltungenDetail$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === VERANSTALTUNG_DETAIL;
        })
        , flatMap(() => {
            return [new GetVeranstaltungenAngelegteAdminAction(),
            new GetVeranstaltungenVeroeffentlichteAdminAction(),
            new GetVeranstaltungenBeendeteAdminAction()];
        })
    );
*/

    @Effect()
    readModelUpdaterAngelegteVeranstaltungenDetailAktuellesDetail$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === VERANSTALTUNG_ENTITY;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <VeranstaltungDetail> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)))
        , filter(([x, detail]) => {
            return detail !== null && x.veranstaltung_id !== null && x.veranstaltung_id !== undefined && x.veranstaltung_id === detail.veranstaltung_id;
        })
        , flatMap(([x, detail]) => {
            return [new GetVeranstaltungDetailAdminAction(x.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheAdminAction(x.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheChecklistenAdminAction(x.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheRollenAdminAction(x.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheRollenAdminAlleAction(x.veranstaltung_id),
                new GetVeranstaltungDokumenteAdminAction(x.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheChecklistenAdminAction(x.veranstaltung_id)
            ];
        })
    );

    @Effect()
    readModelUpdaterAngelegteVeranstaltungenDetailAktuellesDetailRolle$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === VERANSTALTUNG_ENTITY;
        })
        , withLatestFrom(this.store.pipe(select(getAktuelleRolle)))
        , filter(([x, rolle]) => rolle !== null)
        , flatMap(([x, rolle]) => {
            return [new GetRolleBenutzerAction(rolle.vorlage_rolle_id),
                new GetRolleBenutzerAdminAction(rolle.rolle_id)
            ];
        })
    );

    @Effect()
    readModelUpdaterRollen$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === ROLLE_ENTITY;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Rolle> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)))
        , filter(([x, detail]) => detail !== null && x !== null && x.veranstaltung_id === detail.veranstaltung_id)
        , flatMap(([x, rolle]) => {
            return [new GetVeranstaltungFunktionsbereicheRollenAdminAction(rolle.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheRollenAdminAlleAction(rolle.veranstaltung_id)
            ];
        })
    );

    readModelUpdaterRollenRollen$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === ROLLE_ENTITY;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Rolle> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)), this.store.pipe(select(getAktuelleRolle)))
        , filter(([x, detail, rolle]) => detail !== null && x !== null && x.veranstaltung_id === detail.veranstaltung_id)
        , filter(([x, detail, rolle]) => rolle !== null && rolle.rolle_id === x.rolle_id)
        , flatMap(([x, rolle]) => {
            return [new GetRolleBenutzerAction(x.vorlage_rolle_id),
                new GetRolleBenutzerAdminAction(x.rolle_id)
            ];
        })
    );

    @Effect()
    readModelUpdaterFunktionsbereicheDeleteInsert$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === FUNKTIONSBEREICH_ENTITY && (x.message.method === 'DELETE' || x.message.method === 'INSERT');
        })
        , flatMap((x) => {
            return [
                new GetVeranstaltungBenutzerZugriffAction()
            ];
        })
    );

    @Effect()
    readModelUpdaterFunktionsbereicheDelete$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === FUNKTIONSBEREICH_ENTITY && x.message.method === 'DELETE';
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)))
        , filter(([x, detail]) => detail !== null && detail.veranstaltung_id !== null && detail.veranstaltung_id !== undefined)
        , flatMap(([x, detail]) => {
            return [
                // new actionsUi.PageStateResetAction(),
                new GetVeranstaltungDetailAdminAction(detail.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheAdminAction(detail.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheChecklistenAdminAction(detail.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheRollenAdminAction(detail.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheRollenAdminAlleAction(detail.veranstaltung_id),
                new GetVeranstaltungDokumenteAdminAction(detail.veranstaltung_id),
                new GetMitteilungenGruppiertAction(detail.veranstaltung_id),
                new GetMitteilungenGesendetGruppiertAction(detail.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheAction(detail.veranstaltung_id),
                new GetVeranstaltungBerechtigungAction(detail.veranstaltung_id)
                ];
        })
    );

    @Effect()
    readModelUpdaterFunktionsbereiche$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === FUNKTIONSBEREICH_ENTITY && x.message.method !== 'DELETE';
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Funktionsbereich> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)))
        , filter(([x, detail]) => {
            return detail !== null && x !== null && x.veranstaltung_id === detail.veranstaltung_id;
        })
        , flatMap(([x, detail]) => {
            return [
                new GetVeranstaltungFunktionsbereicheAdminAction(detail.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheChecklistenAdminAction(detail.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheAction(detail.veranstaltung_id)
            ];
        })
    );

    @Effect()
    readModelUpdaterRollenBenutzer$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === ROLLE_ENTITY && x.message.entity_part.toUpperCase() === ROLLE_ENTITY_PART_BERECHTIGUNG;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <RolleBenutzer> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)))
        , filter(([x, detail]) => detail !== null && x !== null && x.veranstaltung_id === detail.veranstaltung_id)
        , flatMap(([x, detail]) => {
            return [
                new GetVeranstaltungFunktionsbereicheRollenAdminAction(detail.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheRollenAdminAlleAction(detail.veranstaltung_id)
            ];
        })
    );

    @Effect()
    readModelUpdaterRollenBenutzerRolle$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === ROLLE_ENTITY && x.message.entity_part.toUpperCase() === ROLLE_ENTITY_PART_BERECHTIGUNG;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <RolleBenutzer> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)), this.store.pipe(select(getAktuelleRolle)))
        , filter(([x, detail, rolle]) => detail !== null && rolle !== null && rolle.rolle_id !== null && x.rolle_id === rolle.rolle_id)
        , flatMap(([x, detail, rolle]) => {
            return [
                new GetRolleBenutzerAdminAction(rolle.rolle_id)
            ];
        })
    );

    @Effect()
    readModelUpdaterDokumente$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === DOKUMENT_ENTITY;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Dokument> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)))
        , filter(([x, detail]) => {
            return detail !== null && x !== null && x.veranstaltung_id !== null && x.veranstaltung_id !== undefined && x.veranstaltung_id === detail.veranstaltung_id;
        })
        , flatMap(([x, detail]) => {
            return [
                new GetVeranstaltungDokumenteAdminAction(detail.veranstaltung_id)
            ];
        })
    );

    @Effect()
    readModelUpdaterDokumenteBerechtigungen$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === DOKUMENT_ENTITY
                && x.message.entity_part.toUpperCase() === DOKUMENT_ENTITY_PART_BERECHTIGUNG;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Dokument> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)),
            this.store.pipe(select(getDokumentSelected)))
        , filter(([x, detail, selectedDokument]) => {
            return detail !== null && x !== null && x.veranstaltung_id !== null && x.veranstaltung_id !== undefined && x.veranstaltung_id === detail.veranstaltung_id
                && selectedDokument !== null && x.dokument_id === selectedDokument.dokument_id;
        })
        , flatMap(([x, detail, selectedDokument]) => {
            return [
                new GetVeranstaltungDokumentBerechtigungAction(detail.veranstaltung_id, selectedDokument.dokument_id)
            ];
        })
    );

    @Effect()
    readModelUpdaterChecklisteDelete$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === CHECKLISTE_ENTITY && x.message.method === 'DELETE';
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Checkliste> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)), this.store.pipe(select(getUiSelektiertFunktionsbereicheCheckliste)))
        , filter(([x, detail, checkliste]) => checkliste !== null && detail !== null && x !== null && x.checkliste_id === checkliste.checkliste_id)
        , flatMap(([x, detail, checkliste]) => {
            return [
                new actionsUi.FunktionsbereichChecklisteSetzenAction(null)
            ];
        })
    );

    @Effect()
    readModelUpdaterCheckliste$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === CHECKLISTE_ENTITY; // && x.message.method !== 'DELETE';
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Checkliste> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getUiSelektiertFunktionsbereicheCheckliste)))
        , filter(([x, checkliste]) => checkliste !== null && x !== null && x.checkliste_id === checkliste.checkliste_id)
        , flatMap(([x, checkliste]) => {
            return [
                new GetVeranstaltungFunktionsbereicheChecklistenAdminAction(checkliste.veranstaltung_id)
            ];
        })
    );

    @Effect()
    readModelUpdaterChecklisteStatus$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === CHECKLISTE_ENTITY && x.message.entity_part.toUpperCase() === CHECKLISTE_ENTITY_PART_STATUS;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <ChecklisteStatus> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)))
        , filter(([x, detail]) => detail !== null && x !== null && x.veranstaltung_id === detail.veranstaltung_id)
        , flatMap(([x, detail]) => {
            return [
                new GetVeranstaltungFunktionsbereicheChecklistenAdminAction(detail.veranstaltung_id)
            ];
        })
    );

    @Effect()
    readModelUpdaterChecklistenStatusAufgabe$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === CHECKLISTE_ENTITY && x.message.entity_part.toUpperCase() === CHECKLISTE_ENTITY_PART_STATUS;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <ChecklisteStatus> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)), this.store.pipe(select(getUiSelektiertFunktionsbereicheCheckliste)))
        , filter(([x, detail, checkliste]) => detail !== null && x !== null && checkliste !== null
            && x.veranstaltung_id === checkliste.veranstaltung_id
            && x.checkliste_id === checkliste.checkliste_id)
        , flatMap(([x, detail, checkliste]) => {
            return [
                new GetChecklisteAufgabenAdminAction(x.checkliste_id)
            ];
        })
    );

    @Effect()
    readModelUpdaterAufgabe$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === AUFGABE_ENTITY;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Aufgabe> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)), this.store.pipe(select(getUiSelektiertFunktionsbereicheCheckliste)))
        , filter(([x, detail, checkliste]) => {
            return detail !== null && x !== null && checkliste !== null
            && x.veranstaltung_id === checkliste.veranstaltung_id
            && x.checkliste_id === checkliste.checkliste_id;
        })
        , flatMap(([x, detail, checkliste]) => {
            return [
                new GetChecklisteAufgabenAdminAction(x.checkliste_id)
            ];
        })
    );

    @Effect()
    readModelUpdaterMitteilung$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === MITTEILUNG_ENTITY;
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)))
        , filter(([x, detail]) => detail !== null && x !== null)
        , flatMap(([x, detail]) => {
            return [
                new GetMitteilungenGruppiertAction(detail.veranstaltung_id),
                new GetMitteilungenGesendetGruppiertAction(detail.veranstaltung_id)
            ];
        })
    );

    @Effect()
    readModelUpdaterPandemieLevel$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter ((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === VERANSTALTUNG_ENTITY;
        })
        , withLatestFrom(this.store.pipe(select(getVeranstaltungenDetail)),
            this.store.pipe(select(getIstPandemieLizenzAktiv)))
        , filter(([x, detail, istPandemieAktiv]) => detail !== null && x !== null && istPandemieAktiv)
        , flatMap(([x, detail]) => {
            return [
                new GetVeranstaltungPandemieInfoAction(detail.veranstaltung_id)
            ];
        })
    );

    wsUpdateAufgabenBerechtigungenListen$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === VeranstaltungenEntityTypes.AUFGABE_ENTITY
                && x.message.entity_part.toUpperCase() === VeranstaltungenEntityTypes.AUFGABE_ENTITY_PART_BENUTZER_BERECHTIGUNG;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <Checkliste> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getSelectedFunktionsbereichId)))
        , filter(([checkliste, fbId]) => {
            if (checkliste.funktionsbereich_id === fbId) {
                return true;
            }
            return false;
        })
        , mergeMap(([x, fbId]) =>
            [   new FunktionsbereichSetzenAction(fbId)]
        )
    ));

    wsUpdateAufgabenBerechtigungenDienstplanListen$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === VeranstaltungenEntityTypes.ROLLE_ENTITY
                && x.message.entity_part.toUpperCase() === VeranstaltungenEntityTypes.ROLLE_ENTITY_PART_BERECHTIGUNG;
        })
        , withLatestFrom(this.store.pipe(select(getSelectedFunktionsbereichId)))
        , mergeMap(([x, fbId]) =>
            [   new FunktionsbereichSetzenAction(fbId)]
        )
    ));

    constructor(private actions$: Actions,
                private store: Store<PageState>,
                private notificationService: NotificationService) {
    }
}
